import { render } from "./BataHumanPage.vue?vue&type=template&id=e1f674f6&scoped=true"
import script from "./BataHumanPage.vue?vue&type=script&lang=js"
export * from "./BataHumanPage.vue?vue&type=script&lang=js"

import "@/assets/css/cases.css?vue&type=style&index=0&id=e1f674f6&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f674f6"]])

export default __exports__